import { LOAD_SUBSCRIPTIONS_SUCCESS } from "./actions";

const initialState = {
  channels: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_SUBSCRIPTIONS_SUCCESS:
      return Object.assign({}, state, { channels: action.payload });
    default:
      return state;
  }
}
